import { Spinner } from 'components/Spinner'
import { Suspense, lazy } from 'react'
import type { ExternalPage } from './ExternalEntrypoint'

const ExternalEntrypoint = lazy(() => import('./ExternalEntrypoint'))

// This file is the boundary which allows vite to code split the external pages
function ExternalLoader({ page }: { page: ExternalPage }) {
  return (
    <Suspense fallback={<Spinner className="m-8" />}>
      <ExternalEntrypoint page={page} />
    </Suspense>
  )
}

export function ExternalDemosLoader() {
  return <ExternalLoader page="externalDemos" />
}
